import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the measurementHistory state domain
 */

const selectMeasurementHistoryDomain = (state) =>
  state.get("measurementHistory", initialState)

/**
 * Other specific selectors
 */
// LIST SURVEYS
export const makeSelectIsLoadingListSurveys = () =>
  createSelector(selectMeasurementHistoryDomain, (state) =>
    state.get("isLoadingListSurveys")
  )

export const makeSelectListSurveys = () =>
  createSelector(selectMeasurementHistoryDomain, (state) =>
    state.get("listSurveys")
  )

// LIST MEASUREMENTS
export const makeSelectIsLoadingListMeasurements = () =>
  createSelector(selectMeasurementHistoryDomain, (state) =>
    state.get("isLoadingListMeasurements")
  )

export const makeSelectListMeasurements = () =>
  createSelector(selectMeasurementHistoryDomain, (state) =>
    state.get("listMeasurements")
  )

// HAS COLLABORATORS
export const makeSelectIsLoadingHasCollaborators = () =>
  createSelector(selectMeasurementHistoryDomain, (state) =>
    state.get("isLoadingHasCollaborators")
  )

export const makeSelectHasCollaborators = () =>
  createSelector(selectMeasurementHistoryDomain, (state) =>
    state.get("hasCollaborators")
  )
/**
 * Default selector used by MeasurementHistory
 */

const makeSelectMeasurementHistory = () =>
  createSelector(selectMeasurementHistoryDomain, (substate) => substate.toJS())

export default makeSelectMeasurementHistory
export { selectMeasurementHistoryDomain }
